import React , { useEffect,useState } from 'react';
import { Table,Spin,Popover,Modal,Button,message,Select,InputNumber} from 'antd';
// import { useReactToPrint } from 'react-to-print';


function PlayerCard (props) {
    const data=props.data
    const scoring=props.scoring
    
    const spinner=
    <React.Fragment>
    <Spin />
    </React.Fragment>
    

    const calcPoints=(data)=>{
        const receptionPts= data.Position==='WR'?1.25:(data.Position==='TE'?1.75:1)
        const PointsPer10= (data.Position==='TE'?1.5:1)
        return (Math.round((
            data.Yards*props.scoring[data.Position]["Passing Yards"]+
            data.PassingTouchdowns*props.scoring[data.Position]["Number of Passing TDs"]+
            data.Interceptions*props.scoring[data.Position]["Pass Interceptions Thrown"]+
            data.Receptions*props.scoring[data.Position]["Receptions"]+
            data.ReceivingYards*props.scoring[data.Position]["Receiving Yards"]+
            data.ReceivingTouchdowns*props.scoring[data.Position]["Number of Receiving TDs"]+
            data.RushingTDs*props.scoring[data.Position]["Number of Rushing TDs"]+

            data.RushingYards*props.scoring[data.Position]["Rushing Yards"])*100)/100)
    }
        
    

    const popoverContent=(stat,Percent)=>(
        <div className='flexcol'>
            {props.PFFdata.map(d=><div className='flexrow'><div style={{width:'80px'}}>{d.week||`${d.Year}(${d.Games})`}</div><div>{d[stat]}{Percent?'%':''}</div></div>)}
        </div>
    )//h

   

    const statdiv= (title,stat,changeable,Percent,widthpx)=>(
        <Popover content={popoverContent(stat,Percent)} title="Prior" trigger="hover" placement="right">
        <div className='flexrow stat'>
            <div style={{width:'150px'}}>{title}:</div>
            <div style={{width:'50px'}}> {changeable?<InputNumber style={{ width: 50 }}
                bordered={false}
                min={0} max={100}
                size='small' 
                formatter={value => Percent? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace('%', '')+'%':value}
                parser={value => value.replace('%', '')} 
                value={data[stat]}  
                onPressEnter={(e)=>props.onChange(e,data.NFL_PlayerID,stat)}  width="W10"
                />:<span style={{width:'50px'}}>{data[stat]}{Percent?'%':''}</span>}
            </div>
       
            </div>
        </Popover>
    )

    return (
    <div className='playerCard  flexrow'>
        <div className='playerCardName rightborder'>{data.PlayerName}
        <Popover 
                    content={
                        <div >
                        {statdiv('Passing Yards','Yards',false,false,'110px')}
                        {statdiv('Passing TDs','PassingTouchdowns',false,false,'50px')}
                        {statdiv('Receptions','Receptions',false,false,'110px')}
                        {statdiv('Receiving Yards','ReceivingYards',false,false,'50px')}
                        {statdiv('Receiving TDs','ReceivingTouchdowns',false,false,'50px')}
                        {statdiv('Rushing Yards','RushingYards',false,false,'50px')}
                        {statdiv('Rushing TDs','RushingTDs',false,false,'50px')}
                        {statdiv('Interceptions','Interceptions',false,false,'50px')}
                        </div> 
                    } 
                    title="Prior" trigger="click" placement="top"
                    >
                        <div >{props.proj.filter(p=>calcPoints(p)>calcPoints(data)+.5  && p.Position===data.Position).length+1}-{props.proj.filter(p=>calcPoints(p)>calcPoints(data)-1.5 && p.Position===data.Position).length+1} {props.scoringLoading?<Spin/>:calcPoints(data)} PPG</div> 
                        <div >Age {Math.round(data.Age*10)/10}</div> 
                    </Popover>
            <div >{props.proj.filter(p=>p.FantasyCalcValue>data.FantasyCalcValue+200 && p.Position===data.Position).length+1}-{props.proj.filter(p=>p.FantasyCalcValue>data.FantasyCalcValue-200 && p.Position===data.Position).length+1} {data.FantasyCalcValue} Value</div> 
        </div> 
            {data.Position==='QB'?
            <div className='playerCardStats flexrow'>
                
                <div className='playerCardStatSection' style={{width:'80px'}}>
                    <Popover 
                    content={
                        <div >
                        {statdiv('Passing Attempt Rate','PassAttemptRate',true,true,'160px')}
                        </div> 
                    } 
                    title="Prior" trigger="click" placement="top"
                    >
                        <div >{data.PassingAttempts} Atts</div> 
                    </Popover>
                    <Popover 
                    content={
                        <div >
                        {statdiv('Passing Attempts','PassingAttempts',false,false,'110px')}
                        {statdiv('Expected Comp Percent','XCompletionPercentage',true,true,'160px')}
                        {statdiv('Comp Percent Factor','CompletionPercentageFactor',true,true,'160px')}
                        </div> 
                    } 
                    title="Prior" trigger="click" placement="top"
                    >
                        <div >{data.CompletionPercentage}% Completion</div> 
                    </Popover>
                </div> 
                
                <div className='playerCardStatSection' style={{width:'80px'}}>
                <Popover 
                    content={
                        <div >
                        
                        
                        </div> 
                    } 
                    title="Prior" trigger="click" placement="top"
                    >
                        <div >{data.YardsPerCompletion} YPComp</div> 
                    </Popover>
                    <Popover 
                    content={
                        <div >
                        {statdiv('Expected YPComp','XYardsPerCompletion',true,false,'120px')}
                        {statdiv('YPComp Factor','YardsPerCompletionFactor',true,true,'120px')}
                        {statdiv('YPComp','YardsPerCompletion',false,false,'50px')}
                        {statdiv('Comp Percent','CompletionPercentage',false,true,'110px')}
                        {statdiv('YPA','YardsPerAttempt',false,false,'120px')}
                        {statdiv('Attempts','PassingAttempts',false,false,'120px')}
                        </div> 
                    } 
                    title="Prior" trigger="click" placement="top"
                    >
                        <div >{data.Yards} Yds</div> 
                    </Popover>
                    
                </div>  
                <div className='playerCardStatSection' style={{width:'80px'}}>
                <Popover 
                    content={
                        <div >
                        {statdiv('Passing Attempts','PassingAttempts',false,false,'110px')}
                        {statdiv('Expected TDRate','XPassingTouchdownRate',true,true,'120px')}
                        {statdiv('TD Factor','PassingTouchdownRateFactor',true,true,'120px')}
                        {statdiv('TDRate','PassingTouchdownRate',false,true,'120px')}
                        </div> 
                    } 
                    title="Prior" trigger="click" placement="top"
                    >
                        <div >{data.PassingTouchdowns} TDs</div> 
                    </Popover>
                    <Popover 
                    content={
                        <div >
                        {statdiv('Passing Attempts','PassingAttempts',false,false,'110px')}
                        {statdiv('Expected IntRate','XInterceptionRate',true,true,'120px')}
                        {statdiv('IntRate Factor','InterceptionRateFactor',true,true,'120px')}
                        {statdiv('IntRate','InterceptionRate',false,true,'120px')}
                        </div> 
                    } 
                    title="Prior" trigger="click" placement="top"
                    >
                        <div >{data.Interceptions} INTs</div> 
                    </Popover>
                    
                </div> 
                <div className='playerCardStatSection rightborder' style={{width:'80px'}}>
                <Popover 
                    content={
                        <div >
                        {statdiv('Attempts','PassingAttempts',false,false,'120px')}
                        {statdiv('YPA','YardsPerAttempt',false,false,'120px')}\
                        
                        </div> 
                    } 
                    title="Prior" trigger="click" placement="top"
                    >
                        <div >{data.Yards} Yds</div> 
                    </Popover>
                    <Popover 
                    content={
                        <div >
                        {statdiv('Passing Attempts','PassingAttempts',false,false,'110px')}
                        {statdiv('Expected TDRate','XPassingTouchdownRate',true,true,'120px')}
                        {statdiv('TD Factor','PassingTouchdownRateFactor',true,true,'120px')}
                        {statdiv('TDRate','PassingTouchdownRate',false,true,'120px')}
                        </div> 
                    } 
                    title="Prior" trigger="click" placement="top"
                    >
                        <div >{data.PassingTouchdowns} TDs</div> 
                    </Popover>
                    
                </div> 
                <div className='playerCardStatSection' style={{width:'80px'}}>
                <Popover 
                    content={
                        <div >
                            {statdiv('Carry Share','CarryShare',true,true,'120px')}
                    
                        </div> 
                    } 
                    title="Prior" trigger="click" placement="top"
                    >
                        <div >{data.Carries} Carries</div> 
                    </Popover>
                    <Popover 
                    content={
                        <div >
                            {statdiv('Expected YPCarry','XYardsPerCarry',true,false,'120px')}
                            {statdiv('YPCarry Factor','YardsPerCarryFactor',true,true,'120px')}
                        </div> 
                    } 
                    title="Prior" trigger="click" placement="top"
                    >
                        <div >{data.YardsPerCarry} YPC</div> 
                    </Popover>
                    
                </div>
                <div className='playerCardStatSection rightborder' style={{width:'80px'}}>
                <Popover 
                    content={
                        <div >{statdiv('Carries','Carries',false,false,'120px')}
                            {statdiv('YPCarry','YardsPerCarry',false,false,'120px')}
                        </div> 
                    } 
                    title="Prior" trigger="click" placement="top"
                    >
                        <div >{data.RushingYards} Yds</div> 
                    </Popover>
                    <Popover 
                    content={
                        <div >
                            {statdiv('X Rush TDRate','XRushingTouchdownRate',true,true,'120px')}
                            {statdiv('Rush TD Factor','RushingTouchdownRateFactor',true,true,'120px')}
                            {statdiv('TDRate','RushingTouchdownRate',false,true,'120px')}
                        </div> 
                    } 
                    title="Prior" trigger="click" placement="top"
                    >
                        <div >{data.RushingTDs} TDs</div> 
                    </Popover>
                </div>
            </div>  
            :
            <div className='playerCardStats flexrow'>
       
                <div className='playerCardStatSection' style={{width:'80px'}}>
                    <Popover 
                    content={
                        <div >
                        {statdiv('Route Participation','RouteParticipation',true,true,'160px')}
                        </div> 
                    } 
                    title="Prior" trigger="click" placement="top"
                    >
                        <div >{data.Routes} Rts</div> 
                    </Popover>
                    <Popover 
                    content={
                        <div >
                        {statdiv('Routes','Routes',false,false,'160px')}
                        {statdiv('TPPR','TargetsPerRouteRun',true,true,'160px')}
                        </div> 
                    } 
                    title="Prior" trigger="click" placement="top"
                    >
                        <div >{data.Targets} Tgts</div> 
                    </Popover>
                </div>
                
                <div className='playerCardStatSection' style={{width:'80px'}}>
                    <Popover 
                    content={
                        <div >
                        {statdiv('X Catch Rate','XCatchRate',true,true,'160px')}
                    {statdiv('Catch Rate Factor','CatchRateFactor',true,true,'160px')}
                        </div> 
                    } 
                    title="Prior" trigger="click" placement="top"
                    >
                        <div >{data.CatchRate}% Catch</div> 
                    </Popover>
                    <Popover 
                    content={
                        <div >
                    {statdiv('Expected YPCatch','XYardsPerCatch',true,false,'120px')}
                    {statdiv('YPCatch Factor','YardsPerCatchFactor',true,true,'120px')}
                        </div> 
                    } 
                    title="Prior" trigger="click" placement="top"
                    >
                        <div >{data.YardsPerCatch} YPC</div> 
                    </Popover>
                </div> 
             
                <div className='playerCardStatSection' style={{width:'80px'}}>
                    <Popover 
                    content={
                        <div >
                        {statdiv('Catch Rate','CatchRate',false,true,'160px')}
                        {statdiv('YPCatch','YardsPerCatch',true,false,'120px')}
                        </div> 
                    } 
                    title="Prior" trigger="click" placement="top"
                    >
                        <div >{data.YardsPerTarget} YPT</div> 
                    </Popover>
                    <Popover 
                    content={
                        <div >
                        {statdiv('Targets','Targets',false,false,'110px')}
                        {statdiv('Catch Rate','CatchRate',false,true,'160px')}
                        </div> 
                    } 
                    title="Prior" trigger="click" placement="top"
                    >
                        <div >{data.Receptions} Recs</div> 
                    </Popover>
                </div> 
                <div className='playerCardStatSection rightborder' style={{width:'80px'}}>
                    <Popover 
                    content={
                        <div >
                        {statdiv('Targets','Targets',false,false,'110px')}
                        {statdiv('YPT','YardsPerTarget',false,false,'110px')}
                        </div> 
                    } 
                    title="Prior" trigger="click" placement="top"
                    >
                        <div >{data.ReceivingYards} Yds</div> 
                    </Popover>
                    <Popover 
                    content={
                        <div >
                        {statdiv('Targets','Targets',false,false,'110px')}
                        {statdiv('Expected TDRate','XReceivingTouchdownRate',true,true,'120px')}
                        {statdiv('TD Factor','ReceivingTouchdownRateFactor',true,true,'120px')}
                        {statdiv('TDRate','ReceivingTouchdownRate',false,true,'120px')}
                        </div> 
                    } 
                    title="Prior" trigger="click" placement="top"
                    >
                        <div >{data.ReceivingTouchdowns} TDs</div> 
                    </Popover>
                </div> 
                <div className='playerCardStatSection' style={{width:'80px'}}>
                    <Popover 
                    content={
                        <div >
                            {statdiv('Carry Share','CarryShare',true,true,'120px')}
                    
                        </div> 
                    } 
                    title="Prior" trigger="click" placement="top"
                    >
                        <div >{data.Carries} Carries</div> 
                    </Popover>
                    <Popover 
                    content={
                        <div >
                            {statdiv('Expected YPCarry','XYardsPerCarry',true,false,'120px')}
                            {statdiv('YPCarry Factor','YardsPerCarryFactor',true,true,'120px')}
                        </div> 
                    } 
                    title="Prior" trigger="click" placement="top"
                    >
                        <div >{data.YardsPerCarry} YPC</div> 
                    </Popover>
                </div>
                <div className='playerCardStatSection rightborder' style={{width:'80px'}}>
                    <Popover 
                    content={
                        <div >{statdiv('Carries','Carries',false,false,'120px')}
                            {statdiv('YPCarry','YardsPerCarry',false,false,'120px')}
                        </div> 
                    } 
                    title="Prior" trigger="click" placement="top"
                    >
                        <div >{data.RushingYards} Yds</div> 
                    </Popover>
                    <Popover 
                    content={
                        <div >
                            {statdiv('X Rush TDRate','XRushingTouchdownRate',true,true,'120px')}
                            {statdiv('Rush TD Factor','RushingTouchdownRateFactor',true,true,'120px')}
                            {statdiv('TDRate','RushingTouchdownRate',false,true,'120px')}
                        </div> 
                    } 
                    title="Prior" trigger="click" placement="top"
                    >
                        <div >{data.RushingTDs} TDs</div> 
                    </Popover>
                </div>
            </div>  
}         
    </div>)
    
    }

    export default PlayerCard;
